import { createFileRoute, useNavigate } from '@tanstack/react-router';
import type { CreatePostInput } from '@news-cms/shared';
import { PostForm } from '@/components/posts/post-form';
import { useCreatePost } from '@/lib/posts';
import { useSession } from '@/lib/auth';

export const Route = createFileRoute('/_authenticated/posts/new')({
  component: NewPostPage,
});

function NewPostPage() {
  const { user } = useSession();
  const navigate = useNavigate();
  const create = useCreatePost();

  const handleSubmit = async (data: CreatePostInput) => {
    try {
      const post = await create.mutateAsync(data);
      await navigate({ to: '/posts/$postId', params: { postId: post.id } });
    } catch {
      // surfaced via create.error
    }
  };

  return (
    <div className="p-4 sm:p-8">
      <div className="mx-auto max-w-6xl space-y-6">
        <div>
          <h1 className="text-2xl font-bold tracking-tight text-slate-900 dark:text-slate-50">
            เขียนข่าวใหม่
          </h1>
          <p className="mt-1 text-sm text-slate-500">
            บันทึกเพื่อสร้าง draft แล้วค่อยเผยแพร่ทีหลัง
          </p>
        </div>
        <PostForm
          mode="create"
          user={user}
          onSubmit={handleSubmit}
          isSubmitting={create.isPending}
          error={create.error}
        />
      </div>
    </div>
  );
}
